// 神策初始化
// (async function () {
// try {
//   await loadSensors();
// } catch (error) {
//   console.error('脚本神策sdk加载失败', error);
// }
const overTime = (time) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
};
let VUE_APP_PUBLIC_PREFIX_PATH = 'https://intl-1301408934.cos.accelerate.myqcloud.com'
const loadJs = () => {
  return new Promise((resolve, reject) => {
    // tommy 250519
    // 当前只有国内和亚洲云上报神测埋点，其他云不上报。
    // 所以这里只在国内和亚洲云时才进行埋点初始化
    const host = window.location.host;
    if (
      ![
        'localhost:9001',
        'noc.ruijie.com.cn',
        'cloud-as.ruijienetworks.com',
        'demotest.rj.link',
        'maccdemo.rj.link',
      ].includes(host)
    ) {
      window.sensors = null;
      resolve();
      return;
    }

    const cookieSettingStr = localStorage.getItem('_RC_COOKIE_KEY_SETTING');
    if (cookieSettingStr) {
      let cookieSettingJson = JSON.parse(cookieSettingStr);
      for (let key in cookieSettingJson) {
        if (key === 'statistic' && !cookieSettingJson[key]) {
          window.sensors = null;
          resolve();
          return;
        }
      }
    }

    if (document.getElementById('sensors-js')) return;
    var a = document.createElement('script');
    var verDate = new Date();
    var verStr =
      verDate.getFullYear().toString() +
      verDate.getMonth().toString() +
      verDate.getDate().toString();

    a.type = 'text/javascript';
    a.id = 'sensors-js';
    // a.async = !0;
    a.src = `${VUE_APP_PUBLIC_PREFIX_PATH}/assets/sensorsdata.min.js?v=${verStr}`;
    a.onload = function () {
      let server_sub = 'dev-macc';
      let sensorUrl = 'https://rycem-evt.rj.link/web.gif';

      if (window.location.host.indexOf('noc.ruijie.com.cn') != -1) {
        server_sub = 'macc';
      }

      if (
        window.location.host.indexOf('cloud-') != -1 ||
        window.location.host.indexOf('demotest') != -1
      ) {
        if (window.location.host.indexOf('demotest') != -1) {
          server_sub = 'dev-macc_oversea';
        } else {
          server_sub = 'macc_oversea';
        }
        sensorUrl = 'https://rycem-evt.ruijienetworks.com/web.gif';
      }
      window['sensors'] = window['sensorsDataAnalytic201505']; // 服务端给的埋点key@涂进强 提供
      window.sensors.init({
        server_url: sensorUrl + '?module=yundikan&project=' + server_sub,
        use_client_time: true,
        send_type: 'image',
        show_log: false, // true 本地开始调试，false不开启
        is_track_single_page: true,
        heatmap: {
          //开启全埋点
          //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          clickmap: 'default',
          //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
          scroll_notice_map: 'default',
        },
      });
      window.sensors.quick('autoTrack');
      window['sensorsEvent'] = (type, params) => {
        const map = {
          'noc.ruijie.com.cn': 'CN', // 中国云
          'cloud-a1.ruijienetworks.com': 'RU', // 中亚云
          'cloud-eu.ruijienetworks.com': 'EU', // 欧洲云
          'cloud-as.ruijienetworks.com': 'AS', // 亚洲云
          'cloud-la.ruijienetworks.com': 'LA', // 拉美云
          'cloud-me.ruijienetworks.com': 'ME', // 中东云
          'cloud-us.ruijienetworks.com': 'US', // 美国云
          'cloud-ap.ruijienetworks.com': 'AU', // 澳洲云
          'cloud-uk.ruijienetworks.com': 'UK', // 英国云
        };
        let continent = 'CN';

        for (const key in map) {
          if (Object.hasOwnProperty.call(map, key)) {
            if (window.location.host.includes(key)) {
              continent = map[key];
            }
          }
        }
        window.sensors.track(type, {
          ...params,
          continent: continent,
        });
      };
      resolve();
    };
    a.onerror = reject;
    var c = document.getElementsByTagName('script')[0];
    c.parentNode.insertBefore(a, c);
  });
};
export function loadSensors() {
  return new Promise((resolve, reject) => {
    Promise.race([loadJs(), overTime(3000)])
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}
// })();
